import React, { Component } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './header.module.css'

export default class Header extends Component {

  render() {
    const title = this.props.title
    let sitename = (this.props.h1) ? <h1 className={styles.site_name}>{title}</h1> : <div className={styles.site_name}>{title}</div>
    return (
      <div className={styles.headarea}>
        <header>
          <Link to={`/`}>
            <StaticImage
              className="bio-avatar"
              layout="fixed"
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/logo.png"
              style={{ margin: "0 auto" }}
              height={50}
              alt="Profile picture"
            />
            {sitename}
          </Link>
        </header>
        <p className={styles.headertop}>本サイトはプロモーションを含んでおります。</p>
      </div>
    )
  }
}